module.exports = __webpack_public_path__ + "img/whats-app.279669a5.svg";